import {
  ImpContainer,
  ImpFlex,
  ImpSpacer,
  ImpText,
} from '@imprint-payments/imprint-ui';

import { useImpState } from '../../app/hooks';
import imprintLogoSmall from '../../assets/icons/imprint-logo-small.svg';

interface WelcomeBackCardProps {
  firstName: string;
}

export default function WelcomeBackCard({ firstName }: WelcomeBackCardProps) {
  const { language } = useImpState();

  return (
    <ImpContainer width={'100%'} height={'132px'}>
      <ImpFlex direction="row" align="center" justify="center" fluid>
        <ImpContainer width={'32px'} height={'100%'}>
          <ImpFlex direction="column" align="center" justify="center" fluid>
            <img draggable="false" alt="imprint logo" src={imprintLogoSmall} />
          </ImpFlex>
        </ImpContainer>
        <ImpSpacer width="l" />
        <ImpContainer width={'100%'} height={'100%'}>
          <ImpFlex direction="column" align="center" justify="center" fluid>
            <ImpContainer width={'100%'} height={'32px'}>
              <ImpText typography="headline3">
                {language.reApplicationTitle.replace('$firstName$', firstName)}
              </ImpText>
            </ImpContainer>
            <ImpContainer width={'100%'} height={'48px'}>
              <ImpText typography="body3">{language.reApplicationBody}</ImpText>
            </ImpContainer>
          </ImpFlex>
        </ImpContainer>
      </ImpFlex>
    </ImpContainer>
  );
}
